import { provideMixPanel } from './mixpanel'

export default {
  install: app => {
    provideMixPanel(app)
  }
}
